import { atom } from 'recoil';
import { AdjustmentSubtype } from '../interfaces/AdjustmentSubtype';

export const adjustmentSubtypes = atom({
  key: 'adjustmentSubtypes',
  default: [] as AdjustmentSubtype[],
});
